{
  "title": "rally ops room",
  "guide": "입장 코드를 넣으면 당신이 rally를 열 시각이 카운트다운으로 뜹니다.",
  "ctGuide": "room 관리 코드를 넣으면 ops 를 구성하는 화면이 열립니다.",
  "gameIdGuide": "CT 명부에 등록된 자기 게임 ID 를 넣습니다.",
  "codeLabel": "입장 코드",
  "codePlaceholder": "예: 7K2M9PQR3T",
  "codeSubmit": "다음",
  "confirmTitle": "이 방의 CT 입니다. 맞습니까?",
  "confirmBack": "코드 다시 넣기",
  "confirmNext": "맞습니다",
  "gameIdLabel": "게임 ID",
  "gameIdPlaceholder": "예: 131952426",
  "gameIdSubmit": "입장",
  "joinedTitle": "입장했습니다",
  "joinedBody": "아래 「ops 열람으로」를 누르면 이번 ops 의 rally 목록이 뜹니다. 거기서 자기 rally 를 고르면 개시 카운트다운과 signal 이 시작됩니다.",
  "joinedBodyDefense": "지금 CT 가 수비를 보고 있어 「ops 열람으로」를 누르면 defense 보기가 먼저 열립니다. 자기 rally 의 개시 카운트다운과 signal 은 아래쪽 attack 보기에서 rally 를 고르면 시작됩니다.",
  "presenceTitle": "접속 명단",
  "presenceEmpty": "아직 아무도 들어와 있지 않습니다",
  "presenceStale": "연결이 끊겼습니다. 아래 명단은 지금 값이 아닙니다",
  "sessionGone": "이 접속은 끝났습니다. 입장 코드를 다시 넣어 주세요.",
  "sessionGoneRemoved": "CT 가 명부에서 지웠습니다. 다시 들어오려면 CT 에게 등록을 요청합니다.",
  "sessionGoneKicked": "CT 가 접속을 끊었습니다. 입장 코드를 다시 넣으면 들어옵니다.",
  "connections": "접속",
  "leave": "나가기",
  "ctBranch": "CT 입니까? room 관리 코드로 들어가기",
  "ctCodeLabel": "room 관리 코드",
  "ctCodePlaceholder": "예: 7K2M9PQR3TVWXY01",
  "ctSubmit": "ops 구성 화면으로",
  "ctBack": "입장 코드로 돌아가기",
  "goView": "ops 열람으로"
}
